import axiosInstance from "../../AxiosInstance";
import { URLS } from "../../API/API endpoints";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

export const loginUserRequest = () => ({ type: "LOGIN_USER_REQUEST" });
export const loginUserSuccess = (user) => ({
  type: "LOGIN_USER_SUCCESS",
  payload: user,
});
export const loginUserFailure = (error) => ({
  type: "LOGIN_USER_FAILURE",
  payload: error,
});
export const logoutUserSuccess = () => ({
  type: "LOGOUT_USER_SUCCESS",
  payload: null,
});
export const setContractType = (contractType) => ({
  type: "SET_CONTRACT_TYPE",
  payload: contractType,
});

// In loginAction.js (or a separate storeActions.js)
export const setSelectedStore = (store) => ({
  type: "SET_SELECTED_STORE",
  payload: store,
});

export const setUser = (user) => ({
  type: "SET_USER",
  payload: user,
});

export const setIsMasterStore = (isMaster) => ({
  type: "SET_IS_MASTER_STORE",
  payload: isMaster,
});



export const setMasterStore = (store) => ({
  type: "SET_MASTER_STORE",
  payload: store,
});



export const loginUser =
  (login, password, loginType = "web") =>
  async (dispatch) => {
    dispatch(loginUserRequest());

    try {
      // Check if login is a 10-digit mobile number
      const isMobile = /^\d{10}$/.test(login);

      const payload = {
        [isMobile ? "mobile" : "email"]: login,
        password,
        is_web_login: loginType === "web",
        is_app_login: loginType === "app",
        is_electron_login: loginType === "electron",
      };

      const response = await axiosInstance.post(
        URLS.LOGIN_API_URL,
        payload
      );

      console.log("LOGIN RES--->", response);

      if (response?.data) {
        return response;
      }
    } catch (error) {
      dispatch(loginUserFailure(error.message));
      return error;
    }
  };


export const sendLoginOTP = (phone, isInternalLogin) => async (dispatch) => {
  try {
    const response = await axiosInstance.post(URLS.LOGIN_SEND_OTP, {
      phone: phone?.replace(/^0+/, ''),
      country_code: '+20',
      is_internal: isInternalLogin,
    });

    if (response?.data) {
      return response?.data;
    };
  } catch (error) {
    // dispatch(loginUserFailure(error.message));
    return error;
  }
};


export const verifyLoginOtp = (payload) => async (dispatch) => {
  try {
    const response = await axiosInstance.post(URLS.LOGIN_VERIFY_OTP, payload);

    if (response?.data) {
      return response?.data;
    };
  } catch (error) {
    // dispatch(loginUserFailure(error.message));
    return error;
  }
};

export const LoginData = (payload) => async (dispatch) => {
  try {
    const response = await axiosInstance.post(URLS.GET_LOGIN_DATA, payload);

    if (response?.data) {
      return response?.data;
    };
  } catch (error) {
    // dispatch(loginUserFailure(error.message));
    return error;
  }
};

export const GetLoginRetailers = (payload) => async (dispatch) => {
  try {
    const response = await axiosInstance.post(URLS.GET_LOGIN_RETAILERS, payload);

    if (response?.data) {
      return response?.data;
    };
  } catch (error) {
    // dispatch(loginUserFailure(error.message));
    return error;
  }
};



export const logoutUser = () => async (dispatch) => {
  console.log("logout action called")
  dispatch(logoutUserSuccess());

};


